import React from 'react';
import { Grid } from '@mui/material';
import { TextField, Autocomplete } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { emptyString, emptyArray } from 'constants/defaultValues';
import PropTypes from 'prop-types';

const RtiComponent = ({ data, financingTypes }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} lg={4}>
        <TextField
          id={'Rti_FinancingOfferNumber'}
          fullWidth
          value={data.financingDocumentNumber || emptyString}
          label={t('Offer.Edit.Rti.FinancingOfferNumber')}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <Autocomplete
          id={'Rti_FinancingType'}
          label={t('Offer.Edit.Rti.FinancingType')}
          fullWidth
          required
          valueKey='name'
          labelKey='name'
          value={data.financingType}
          options={financingTypes || emptyArray}
          disabled={true}
          simpleValue={true}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <TextField
          id={'Rti_AssetType'}
          fullWidth
          value={data.assetType || emptyString}
          label={t('Offer.Edit.Rti.AssetType')}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <TextField
          id={'Rti_ManufacturingYear'}
          fullWidth
          value={data.manufacturingYear || emptyString}
          label={t('Offer.Edit.Rti.ManufacturingYear')}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <TextField
          id={'Rti_CurrentMileage'}
          fullWidth
          value={data.currentMileage || emptyString}
          label={t('Offer.Edit.Rti.CurrentMileage')}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <TextField
          id={'Rti_AssetPriceWithVAT'}
          isNumeric={true}
          fullWidth
          value={data.purchasePrice || emptyString}
          label={t('Offer.Edit.Rti.AssetPriceWithVAT')}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <TextField
          id={'Rti_Currency'}
          fullWidth
          value={data.currencyCode || emptyString}
          label={t('Offer.Edit.Rti.Currency')}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <TextField id={'Rti_Period'} fullWidth value={data.period || emptyString} label={t('Offer.Edit.Rti.Period')} disabled={true} />
      </Grid>
    </Grid>
  );
};

RtiComponent.propTypes = {
  data: PropTypes.object,
  financingTypes: PropTypes.array
};

export default RtiComponent;
